import { render, staticRenderFns } from "./VisualizarMapa.vue?vue&type=template&id=2b53d791&"
import script from "./VisualizarMapa.vue?vue&type=script&lang=js&"
export * from "./VisualizarMapa.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarMapa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports